import { render, staticRenderFns } from "./TableJobs.vue?vue&type=template&id=4c821c0b&scoped=true&"
import script from "./TableJobs.vue?vue&type=script&lang=js&"
export * from "./TableJobs.vue?vue&type=script&lang=js&"
import style0 from "./TableJobs.vue?vue&type=style&index=0&id=4c821c0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c821c0b",
  null
  
)

export default component.exports